import { FC } from 'react'
import { Box } from '@/components/atoms/Grid'
import { ListItemSeparator } from '@/components/atoms/separator'
import styled, { useTheme } from 'styled-components'
import useTranslation from 'next-translate/useTranslation'
import { CheckIconDefault } from '@/components/atoms/icons/CheckIconDefault'
import { IconButtonRedesign } from '@/components/molecules/iconButtons/iconButton'

type FilterSlidePageFooterRedesignProps = {
  onFilterDidTap: () => void
  customTitle?: string
  disabled?: boolean
} & Rest

const FilterSlidePageFooterRedesign: FC<FilterSlidePageFooterRedesignProps> = ({
  onFilterDidTap,
  customTitle,
  disabled,
  ...rest
}) => {
  const { t } = useTranslation('common')
  const theme = useTheme()
  const buttonKey = customTitle || 'main-filter-button'

  return (
    <Wrapper data-testid="filterFooter">
      <StyledSeparator />
      <StyledIconButton
        key={buttonKey}
        title={customTitle || t('Category.Filter.showProducts')}
        onClick={onFilterDidTap}
        disabled={disabled}
        {...rest}
        IconElement={
          <CheckIconDefault
            height={11}
            width={15}
            color={theme.colors.background}
          />
        }
      />
    </Wrapper>
  )
}

export default FilterSlidePageFooterRedesign

const Wrapper = styled(Box)`
  text-align: center;
  background-color: ${(props) => props.theme.colors.background};
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
`

const StyledSeparator = styled(ListItemSeparator)`
  margin: 8px 0 16px;
`

const StyledIconButton = styled(IconButtonRedesign)<{ disabled?: boolean }>`
  width: calc(100% - 32px);
  margin: 0 16px 16px;
  border-radius: 4px;
  color: ${(props) => props.theme.colors.background};
  background-color: ${(props) => props.theme.colors.onBackground};
  height: 42px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;

  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  p {
    font-size: 14px;
    margin: 0;
  }
`
